export default __webpack_public_path__ + "static/media/top-section-bg.24fde71f.png";